import scrollTo from 'animated-scroll-to';
import { viewport } from './Viewport';

const offset = {
  mobile: 0,
  desktop: -120,
};

export default class Anchors {
  constructor() {
    this.id = '';

    // Manage URLs containing a hash
    // If an id'd element exists, scroll to it.
    if (window.location.hash) {
      this.id = window.location.hash.substr(1);
    }

    const msgs = document.querySelectorAll('.cc-window.cc-top.fixed-top:not(.cc-invisible)').length;
    if (msgs.length > 0) {
      // Get height of all messages and fix the offset.
      const total = document.querySelector('.cc-window').offsetHeight * msgs;
      offset.desktop -= total;
    }

    // Listen for click events on links starting with a hash.
    // If an id'd element exists, scroll to it.
    const anchors = document.querySelectorAll('a[href^="#"]');
    anchors.forEach((anchor) => {
      anchor.addEventListener('click', this.clickHandler.bind(this));
    });
  }

  clickHandler(event) {
    // Prevent default browser based hash functionality.
    event.preventDefault();

    // Extract the hash to use as the element id to search for.
    this.id = event.currentTarget.href.substr(event.currentTarget.href.indexOf('#') + 1);

    // Locate destination within the document.
    const destination = document.getElementById(this.id);

    // Quit if the destination isn't found
    if (!destination) return;

    // Scroll to destination.
    scrollTo(destination, {
      verticalOffset: viewport.mobileState ? offset.mobile : offset.desktop,
      maxDuration: 1000,
      minDuration: 250,
      speed: 1000,
    });
  }
}
